import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
export function ObjectionsSection() {
  const objections = [{
    q: 'No tengo espacio',
    a: 'El sistema está diseñado para adaptarse desde balcones de 1x1 hasta grandes patios. Te enseñamos a cultivar en vertical y en macetas.'
  }, {
    q: 'No tengo experiencia',
    a: 'Mejor. Así no tienes vicios ni malos hábitos. El manual te lleva desde cero absoluto hasta tu primera cosecha.'
  }, {
    q: 'No tengo mucho tiempo',
    a: 'Una huerta bien planificada solo requiere 15 minutos al día. El sistema te enseña a automatizar y simplificar tareas.'
  }, {
    q: 'Ya intenté y me fue mal',
    a: 'Fallaste porque te faltaba el método. Con las instrucciones correctas sobre suelo, riego y luz, es imposible no ver resultados.'
  }];
  return <section className="py-20 px-4 bg-zinc-950" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <div className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl font-bold text-white flex items-center justify-center gap-3" data-id="element-130">
            <HelpCircle className="w-8 h-8 text-zinc-500" data-id="element-131" />
            ¿Tienes dudas? Las respondemos.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-132">
          {objections.map((obj, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="p-6 bg-zinc-900 rounded-lg border-l-4 border-green-500 shadow-lg" data-id="element-133">
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-134">{obj.q}</h3>
              <p className="text-zinc-400" data-id="element-135">{obj.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}